import { render, staticRenderFns } from "./custom-pagination.vue?vue&type=template&id=4bf12e14&scoped=true&"
import script from "./custom-pagination.vue?vue&type=script&lang=js&"
export * from "./custom-pagination.vue?vue&type=script&lang=js&"
import style0 from "./custom-pagination.vue?vue&type=style&index=0&id=4bf12e14&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4bf12e14",
  null
  
)

export default component.exports